<script lang="ts">
	import { locale } from '$lib/translations';

	import bigramImage from '$lib/images/bigram.svg';
</script>

<a href={`/${$locale}`} class="block rounded-full p-2 md:p-4 -my-4 md:-my-4 bg-dark-gray | logo">
	{#key $locale}
		<img src={bigramImage} alt="sistrall.it" class="aspect-square h-8" />
	{/key}
</a>

<style lang="postcss">
	.logo {
		display: block;

		box-shadow:
			inset 4px 4px 8px #222222,
			inset -4px -4px 8px #444444;

		@media screen(md) {
			box-shadow:
				inset 8px 8px 16px #222222,
				inset -8px -8px 16px #444444;
		}
	}
</style>
